import { render, staticRenderFns } from "./UserEPwd_User_Details.vue?vue&type=template&id=5775e54c"
import script from "./UserEPwd_User_Details.vue?vue&type=script&lang=js"
export * from "./UserEPwd_User_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports